module.exports = __webpack_public_path__ + "img/pic2.fccb4ef9.png";